import { render } from "./AddressDetailsQr.vue?vue&type=template&id=19564e49&scoped=true"
import script from "./AddressDetailsQr.vue?vue&type=script&lang=js"
export * from "./AddressDetailsQr.vue?vue&type=script&lang=js"

import "./AddressDetailsQr.vue?vue&type=style&index=0&id=19564e49&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19564e49"

export default script